import React from 'react'

// Shared UI icons. Drawn rather than typed as glyphs, which render at whatever
// weight the system font gives them. Same 24-grid stroke convention as
// WidgetTypeIcon.
const commonProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

/** Points down when collapsed; the caller rotates it when the row is open. */
export const ChevronIcon: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <svg {...commonProps} width={size} height={size} aria-hidden="true">
    <polyline points="6 9 12 15 18 9" />
  </svg>
)

export const TrashIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <svg {...commonProps} width={size} height={size} aria-hidden="true">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
  </svg>
)

/** A box with an arrow leaving its top-right corner: opens in a new window. */
export const ExternalLinkIcon: React.FC<{ size?: number }> = ({ size = 12 }) => (
  <svg {...commonProps} width={size} height={size} aria-hidden="true">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
)
